import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Alert, Button, TextField, Checkbox, FormControlLabel } from '@mui/material';
import { useAuth } from '../../contexts';
import './login-sign.scss';
import { PASSWORD_REGEX, EMAIL_REGEX } from '../../consts/regex';
import { TEXT_ERROR_NAME, TEXT_ERROR_PASSWORD, TEXT_ERROR_RE_PASSWORD } from '../../consts/error-text';

export const LoginOn = () => {
    const [email, setEmail] = useState('');
    const [errorEmail, setErrorEmail] = useState(false);
    const [password, setPassword] = useState('');
    const [errorPassword, setErrorPassword] = useState(false);
    const [rePassword, setRePassword] = useState('');
    const [errorRePassword, setErrorRePassword] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showRePassword, setShowRePassword] = useState(false);
    const [error, setError] = useState('');

    const navigate = useNavigate();
    const { login } = useAuth();
    const isEmailValid = (email) => EMAIL_REGEX.test(email);
    const isPasswordValid = (password) => PASSWORD_REGEX.test(password);
    const isRePasswordValid = (rePassword, password) => rePassword === password;
    const isDisable =
        (!email || errorEmail) || (!password || errorPassword) || (!rePassword || errorRePassword);
    const handlerName = (value) => {
        setEmail(value);
        setErrorEmail(!isEmailValid(value));
    };
    const handlerPassword = (value) => {
        setPassword(value);
        setErrorPassword(!isPasswordValid(value));
        rePassword && setErrorRePassword(!isRePasswordValid(rePassword, value));
    };
    const handlerRePassword = (value) => {
        setRePassword(value);
        setErrorRePassword(!isRePasswordValid(value, password));
    };
    const handlerShowPassword = (value) => setShowPassword(value);
    const handlerReShowPassword = (value) => setShowRePassword(value);
    const handleSubmit = async (element) => {
        element.preventDefault();
        try {
            setError('');
            await login(email, password);
            navigate('/');
        } catch (error) {
            console.log(error);
            setError(`Помилка в створені ${error.message}`);
        }
    };

    return (
        <div className='login'>
            <h2 className='login-title'>Реєстрація</h2>
            {error &&
                <Alert severity='error' sx={{ marginBottom: '16px' }}>
                    {error}
                </Alert>
            }
            <form
                className='login-form'
                autoComplete='off'
                onSubmit={handleSubmit}
                noValidate>
                <TextField
                    type='email'
                    error={errorEmail}
                    id='outlined-error'
                    label='Електронна адреса'
                    placeholder='Введіть електронну адресу'
                    value={email}
                    onChange={e => handlerName(e.target.value)}
                    sx={{ marginBottom: '20px' }}
                    helperText={errorEmail && TEXT_ERROR_NAME} />
                <div className='login-form_password'>
                    <TextField
                        type={showPassword ? 'text' : 'password'}
                        error={errorPassword}
                        id='outlined-error'
                        label='Пароль'
                        placeholder='Введіть пароль'
                        value={password}
                        onChange={e => handlerPassword(e.target.value)}
                        helperText={errorPassword && TEXT_ERROR_PASSWORD}
                    />
                    <FormControlLabel control={
                        <Checkbox inputProps={{ 'aria-label': 'Checkbox demo' }}
                            sx={{ color: '#6565f5', '&.Mui-checked': { color: '#6565f5' } }}
                            checked={showPassword}
                            onChange={e => handlerShowPassword(e.target.checked)} />
                    } label='Показати пароль' />
                </div>
                <div className='login-form_password'>
                    <TextField
                        type={showRePassword ? 'text' : 'password'}
                        error={errorRePassword}
                        id='outlined-error'
                        label='Повторити пароль'
                        placeholder='Повторіть пароль'
                        value={rePassword}
                        onChange={e => handlerRePassword(e.target.value)}
                        helperText={errorRePassword && TEXT_ERROR_RE_PASSWORD} />
                    <FormControlLabel control={
                        <Checkbox inputProps={{ 'aria-label': 'Checkbox demo' }}
                            sx={{ color: '#6565f5', '&.Mui-checked': { color: '#6565f5' } }}
                            checked={showRePassword}
                            onChange={e => handlerReShowPassword(e.target.checked)} />
                    } label='Показати пароль' />
                </div>
                <Button
                    sx={{
                        backgroundColor: '#6565f5',
                        '&:hover': { backgroundColor: '#4d4de9' }
                    }}
                    variant='contained'
                    disabled={isDisable}
                    type='submit'>
                    Зареєструватися
                </Button>
            </form>
        </div>
    )
}